export const formatDateTime = (iso) => {
    try {
        return new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
    } catch (_) {
        return iso;
    }
};

export const buildResponseJson = (entry) => {
    if (entry.status === 'clarification') {
        return JSON.stringify({ status: 'clarification', message: entry.message }, null, 2);
    }
    return JSON.stringify({
        status: 'ready',
        ...(entry.groups && entry.groups.length > 0 ? { groups: entry.groups } : {}),
        steps: entry.steps,
        notes: entry.notes,
        referenced_variables: entry.referencedVariables,
    }, null, 2);
};

export const blocksFromStepMap = (stepMap) => Object.entries(stepMap).map(([stepId, entry]) => ({ stepId, type: entry.type, blockId: entry.objectId }));

export const countExistingBlocks = (entry, existingBlockIds) => entry.blocks.filter((block) => existingBlockIds.has(block.blockId)).length;

export const entryBadge = (entry, existingBlockIds) => {
    if (entry.status === 'clarification') return { label: 'Question', className: 'neutral' };
    if (entry.status === 'failed') return { label: 'Failed', className: 'danger' };
    if (entry.blocks.length > 0 && countExistingBlocks(entry, existingBlockIds) === 0) return { label: 'Blocks removed', className: 'muted' };
    if (entry.source === 'replay') return { label: 'Re-created', className: 'ok' };
    return { label: 'Created', className: 'ok' };
};
